
import { FrontendEncryption } from './index';
import APIURL from "../../Main/apiurl";

const ENCRYPTION_KEY = process.env.REACT_APP_ENCRYPTION_KEY || 'qqqqqqqqqqwwwwwww33333455666gggggggggg%%%%%';

class EncryptedApiService {
    constructor() {
        this.encryptor = new FrontendEncryption(ENCRYPTION_KEY);
        this.baseURL = APIURL;
    }

    async makeEncryptedRequest(endpoint, data, method = 'POST') {
        try {
            const encryptedData = this.encryptor.createEncryptedPayload(data);

            const token = localStorage.getItem("user");

            const response = await fetch(`${this.baseURL}${endpoint}`, {
                method: method,
                headers: {
                    'Content-Type': 'application/json',
                    'X-Encrypted-Request': 'true',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({ encrypted: encryptedData }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const responseData = await response.json();

            if (responseData.encrypted) {
                return this.encryptor.extractFromEncryptedResponse(responseData.encrypted);
            } else {
                throw new Error('No encrypted data in response');
            }
        } catch (error) {
            console.error('API request failed:', error);
            throw error;
        }
    }

    async encryptedGet(endpoint) {
        return this.makeEncryptedRequest(endpoint, {}, 'GET');
    }

    async encryptedPost(endpoint, data) {
        return this.makeEncryptedRequest(endpoint, data, 'POST');
    }

    async encryptedPut(endpoint, data) {
        return this.makeEncryptedRequest(endpoint, data, 'PUT');
    }

    async encryptedDelete(endpoint, data = {}) {
        return this.makeEncryptedRequest(endpoint, data, 'DELETE');
    }
}

export const encryptedApi = new EncryptedApiService();